export function required(val) {
    return !!val || 'To pole jest wymagane'
}

export function notBlank(val, allowNull = true) {
    if (allowNull && val === null) return true
    return !!val
}

export function minLength(val) {
    let value = val.replace(/\s/g, "");
    value = val.replace(/\n/g, "");
    return value.length > 15 || false
}
export function minLengthMessage(val) {
    let value = val.replace(/\s/g, "");
    value = val.replace(/\n/g, "");
    return value.length > 0 || false
}
export function name(val) {
    return /[a-zA-z]/.test(val) || false
}

export function buildings(val) {
    if (!val) return true
    return /[1-9]/.test(val) || false
}

export function email(val) {
    if (!val) return true
    return /.+@.+\..+/.test(val) || false
}

export function phoneNumber(val) {
    if (!val) return true
    return /[0-9]{9}/.test(val) || false
}

export function city(val) {
    if (!val) return true
    return /[1-9a-zA-z]/.test(val) || false
}

export function postalCode(val) {
    if (!val) return true
    return /[1-9a-zA-z]/.test(val) || false
    // return /[0-9]{2}[\-][0-9]{3}/.test(val) || /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(val) || false
}

export function nip(val) {
    if (!val) return true
    return /^[0-9]{10}$/.test(val) || false
}

export function password(val) {
    if (!val) return true
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(val) || false
}
